// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"QD-z","smallCardRow":"RD-z","largeCardRow":"SD-z","productSearchRow":"TD-z","curatedRow":"UD-z"};